/**
 * @generated SignedSource<<18f187046e493bc63d953540bf4d6b3d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type context_nativeIssueTable_IFCConfigContextProvider_queryRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"getSelectedOptions">;
  readonly " $fragmentType": "context_nativeIssueTable_IFCConfigContextProvider_queryRef";
};
export type context_nativeIssueTable_IFCConfigContextProvider_queryRef$key = {
  readonly " $data"?: context_nativeIssueTable_IFCConfigContextProvider_queryRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"context_nativeIssueTable_IFCConfigContextProvider_queryRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "type"
},
v1 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "context_nativeIssueTable_IFCConfigContextProvider_queryRef",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getSelectedOptions",
      "selections": [
        {
          "concreteType": "JiraIssueEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 500
                }
              ],
              "concreteType": "JiraIssueFieldSetConnection",
              "kind": "LinkedField",
              "name": "fieldSets",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldSetEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldSet",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "concreteType": "JiraIssueFieldConnection",
                          "kind": "LinkedField",
                          "name": "fields",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "JiraIssueFieldEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "__typename"
                                    },
                                    {
                                      "kind": "ScalarField",
                                      "name": "fieldId"
                                    },
                                    (v0/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "concreteType": "JiraOptionConnection",
                                          "kind": "LinkedField",
                                          "name": "selectedOptions",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "concreteType": "JiraOptionEdge",
                                              "kind": "LinkedField",
                                              "name": "edges",
                                              "plural": true,
                                              "selections": [
                                                {
                                                  "concreteType": "JiraOption",
                                                  "kind": "LinkedField",
                                                  "name": "node",
                                                  "plural": false,
                                                  "selections": [
                                                    {
                                                      "kind": "ScalarField",
                                                      "name": "id"
                                                    },
                                                    {
                                                      "kind": "ScalarField",
                                                      "name": "value"
                                                    }
                                                  ]
                                                },
                                                (v1/*: any*/)
                                              ]
                                            }
                                          ]
                                        }
                                      ],
                                      "type": "JiraCheckboxesField"
                                    },
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "concreteType": "JiraOption",
                                          "kind": "LinkedField",
                                          "name": "fieldOption",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "ScalarField",
                                              "name": "optionId"
                                            }
                                          ]
                                        }
                                      ],
                                      "type": "JiraSingleSelectField"
                                    },
                                    (v1/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        (v1/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldSets(first:500)"
            }
          ]
        }
      ],
      "argumentDefinitions": []
    }
  ],
  "type": "JiraIssueConnection"
};
})();

(node as any).hash = "0831223130cceb4db1fa0dc5958c658a";

export default node;
